module.exports = __webpack_public_path__ + "img/hotel11.88832070.png";